import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { GiftCardOrderSalesModel, GiftCardVirtualsModel } from "src/app/models/gifcardVirtual.model";
import { saveAs } from 'file-saver';
import { AuthService } from 'src/app/services/auth.service';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';
import { TraceService } from 'src/app/services/trace.service';
import { GifcardFisicaService } from 'src/app/services/giftcardFisica.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ParameterModel } from 'src/app/models/parameter.model';
import { ParameterService } from 'src/app/services/parameter.service';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';

@Component({
  selector: 'app-ordersales-fisica-step3-list',
  templateUrl: './ordersales-fisica-step3-list.component.html',
  styleUrls: ['./ordersales-fisica-step3-list.component.css']
})
export class OrdersalesFisicaStep3ListComponent implements OnInit, OnDestroy {

  constructor(private giftCardFisicaService: GifcardFisicaService,
    private giftCardService: GifcardVirtualService,
    private messageService: MessageService,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    private traceService: TraceService,
    private formBuilder: FormBuilder,
    private parameterService: ParameterService) { }

  private subscription: Subscription = new Subscription();
  totalOrderSales: number;
  dlgOrderSales: boolean;
  dlgEmailFails: boolean;
  dlgUpdateEmail: boolean;
  itemOrderSales;
  itemSendFails;
  selectOrderSales: GiftCardOrderSalesModel;
  datasourceTablaOrderSales: GiftCardOrderSalesModel[] = [];
  colsTablaOrderSales: any[];
  colsTablaEmailFails: any[];
  dataDetail: {};
  datasourceGiftCardVirtual: GiftCardVirtualsModel[] = [];
  loading: boolean = false;
  currentUser: string;
  observation: string;
  dlgReject: boolean = false;
  orderSalesFormGroup: FormGroup;
  permLow: number = 0;
  permMedium: number = 0;
  permHigh: number = 0;
  datasourceParameters: ParameterModel[] = [];

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
    this.createColumnsTablaGiftCardVirtual();
    this.populateListParameters();
    this.createOrderSalesForm();
    this.populateTableOrderSales();
    //this.refreshData();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  refreshData() {
    this.subscription.add(this.populateTableOrderSales());
    this.subscription.add(this.subscribeToData());
  }

  subscribeToData() {
    this.subscription.add(console.log("refreshdata"));
    this.subscription.add(
      timer(60000).subscribe(() => this.refreshData())
    );
  }

  createOrderSalesForm() {
    this.orderSalesFormGroup = this.formBuilder.group({
      txtBranch: ['', [Validators.required, Validators.pattern('[0-9]*'), Validators.maxLength(3)]],
      txtSerieIni: ['', [Validators.required, Validators.pattern('[0-9]*')]],
      txtSerieFin: ['', [Validators.required, Validators.pattern('[0-9]*')]],
      txtMontoNeto: ['', [Validators.required, Validators.pattern('^(0|([1-9][0-9]*))(\\.[0-9]+)?$')]],
      txtObservaciones: ['']
    });
  }

  createColumnsTablaGiftCardVirtual() {
    this.colsTablaOrderSales = [
      { field: 'NRO_ORDEN_COMPRA', header: 'Nro. Ord. Compra', width: '8%', align: 'center' },
      { field: 'DESC_MODELO_GIFT_CARD', header: 'Modelo Giftcard', width: '10%', align: 'center' },
      { field: 'NRORUC_CLIENTE', header: 'RUC', width: '7%', align: 'center' },
      { field: 'RAZSOC_CLIENTE', header: 'Razón Social', width: '25%', align: 'center' },
      { field: 'IMP_ORDEN_COMPRA', header: 'Importe', width: '8%', align: 'center' },
      { field: 'CAN_ORDEN_COMPRA', header: 'Cant.', width: '6%', align: 'center' },
      { field: 'CREATIONUSER', header: 'Usuario Aprobador', width: '6%', align: 'center' },
      { field: 'CREATIONDATE', header: 'Fecha Aprobación', width: '6%', align: 'center' },
      { field: 'PERMANENCIA', header: 'Días Perman.', width: '6%', align: 'center' }
    ];
  }

  populateTableOrderSales() {
    this.loading = true;
    let params = {
      "p_flag_activo": 7,
      "p_isfacturado":"N"
    }

    this.giftCardFisicaService.GetOrderSalesFisicaByStatus(params).subscribe(
      (response: GiftCardOrderSalesModel[]) => {
        this.datasourceTablaOrderSales = response;
        this.totalOrderSales = this.datasourceTablaOrderSales.length;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar las ordenes de compra.' });
      }
    )
  }

  populateListParameters() {
    this.parameterService.GetGiftCardParameters().subscribe(
      (response: ParameterModel[]) => {
        this.datasourceParameters = response;
        if (this.datasourceParameters) {
          this.datasourceParameters.forEach(param => {
            if (param.KEY_PARAMETER == 'GCF_PERM_LOW')
              this.permLow = Number(param.VALUE_SHORT);
            else if (param.KEY_PARAMETER == 'GCF_PERM_MEDIUM')
              this.permMedium = Number(param.VALUE_SHORT);
            else if (param.KEY_PARAMETER == 'GCF_PERM_HIGH')
              this.permHigh = Number(param.VALUE_SHORT);
          });
        }
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar parámetros.' });
      }
    )
  }

  calculateCountGiftCardFisico() {
    this.loading = true;

    if (this.serieini.value > this.seriefin.value) {
      this.loading = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'El número de rango inicial no puede ser mayor que el rango final.' });
      return;
    }

    let p_model = '212121' + this.zfill(this.itemOrderSales.ID_TYPES_NCR, 3);
    let params = {
      "p_model": p_model,
      "p_branch": this.branch.value,
      "p_begin_sequence": this.serieini.value,
      "p_final_sequence": this.seriefin.value
    }
    this.giftCardService.GetGiftCardFisicoCount(params).subscribe(
      (response) => {
        let cantidad = response[0].cantidad;
        if (cantidad > 0) {
          this.onShowConfirmApprove(cantidad);
          this.loading = false;
        }
        else {
          this.loading = false;
          this.messageService.add({ severity: 'warn', summary: 'Alerta', detail: 'No existen resultados con los datos ingresados.' });
        }

      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al obtener la cantidad de giftcard a activar.' });
      }
    )
  }

  activarGiftcardFisico() {
    let p_model = '212121' + this.zfill(this.itemOrderSales.ID_TYPES_NCR, 3);
    let params = {
      "p_model": p_model,
      "p_branch": this.branch.value,
      "p_begin_sequence": this.serieini.value,
      "p_final_sequence": this.seriefin.value,
      "p_net_amount": this.montoNeto.value,
    }
    this.giftCardService.UpdateGiftCardStatusFisico(params).subscribe(
      (response) => {
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Activación realizada correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al obtener la cantidad de giftcard a activar.' });
      }
    )
  }

  onShowConfirmApprove(cantidad: number) {
    this.confirmationService.confirm({
      message: '¿Está seguro de activar ' + cantidad + ' giftcard físicas de la orden de compra?',
      accept: () => {
        this.loading = true;
        this.activarGiftcardFisico();
        this.updateOrderSalesStatus(1);
        this.createOrderSalesTrace('ACTIVADO');
      },
      reject: () => {
        this.loading = false;
      }
    });
  }

  createOrderSalesTrace(status: string) {
    let params = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
      "p_type_order_sales": this.giftCardFisicaService.TYPE_ORDER_SALES_FISICA,
      "p_action": status,
      "p_observation": this.observation ? this.observation : 'Activado Correctamente.',
      "p_creationuser": this.currentUser
    };
    this.traceService.CreateGiftCardOrderSalesTrace(params).subscribe(
      (response) => {
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Trace registrado correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear el trace de la orden de compra' });
      }
    )
  }

  updateOrderSalesStatus(flg_activo: number) {
    let params = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
      "p_flg_activo": flg_activo
    }
    this.giftCardFisicaService.UpdateOrderSalesFisicaStatus(params).subscribe(
      (response) => {
        this.dlgOrderSales = false;
        this.dlgReject = false;
        this.populateTableOrderSales();
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Actualización del estado de la orden de compra: exitoso.' });
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el estado de la orden de compra.' });
      }
    )
  }

  onShowDlgReject() {
    this.dlgReject = true;
  }

  onShowDlgOrderSales(order: GiftCardOrderSalesModel) {
    this.itemOrderSales = order;
    this.dlgOrderSales = true;
  }
  
  zfill(number, width) {
    var numberOutput = Math.abs(number); /* Valor absoluto del número */
    var length = number.toString().length; /* Largo del número */
    var zero = "0"; /* String de cero */

    if (width <= length) {
      if (number < 0) {
        return ("-" + numberOutput.toString());
      } else {
        return numberOutput.toString();
      }
    } else {
      if (number < 0) {
        return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
      } else {
        return ((zero.repeat(width - length)) + numberOutput.toString());
      }
    }
  }

  downloadIMGOrder() {
    saveAs(this.itemOrderSales.IMG_ORDEN_COMPRA, "orden.jpg");
  }

  downloadIMGCotizacion() {
    saveAs(this.itemOrderSales.IMG_COTIZACION, "cotizacion.jpg");
  }

  donwloadAdicional1() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL1, "adicional.jpg");
  }

  donwloadAdicional2() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL2, "adiciona2.jpg");
  }

  donwloadAdicional3() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL3, "adiciona3.jpg");
  }

  get branch() {
    return this.orderSalesFormGroup.get('txtBranch');
  }

  get serieini() {
    return this.orderSalesFormGroup.get('txtSerieIni');
  }

  get seriefin() {
    return this.orderSalesFormGroup.get('txtSerieFin');
  }

  get montoNeto() {
    return this.orderSalesFormGroup.get('txtMontoNeto');
  }
}